import CopyLink from "@/tool/copyLink.js";
import Images from "@/tool/imageLoader";
export default {
  install(Vue) {
    Vue.prototype.$copyLink = CopyLink;
    // 将图片对象挂载到 Vue 实例上
    Vue.prototype.$images = Images;
    // 可以继续添加其他工具函数
    // Vue.prototype.$otherFunction = otherFunction;
  },
};
